import React, { Component } from 'react'
import Person from './Person'
import Skills from './Skills'

export default class LeftColumn extends Component {

    render() {
        return (
            <div className="w3-third">
                <Person/>
                <br></br>
                <Skills/>
            </div>
        )
    }
}